import ErrorPanel, {ErrorPanelWithTrackEvent} from './ErrorPanel';
export {ErrorPanel as default, ErrorPanelWithTrackEvent};
